import React from "react";
import { Box, useTheme } from "@mui/material";
import AxionControls from "../../../components/controls/AxionControls";
import Checkbox from "../../../components/controls/Checkbox";
import Button from "../../../components/controls/Button";
import { tokens } from "../../../assets/theme";
import messages from "./messages";
import { FormattedMessage, useIntl } from "react-intl";

export default function ReadingTypeDialog(props) {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { formatMessage } = useIntl();

    const handleChange = (event) => {
        const {id, name, value, type, checked} = event.target
        console.log(event.target)
        props.setReadingType(prev => {
            return {
                ...prev,
                [id ? id : name]: type === "checkbox" ? checked : value
            }
        })
    }

    const handleNumericChange = (event) => {
        let {id, name, value, type, checked} = event.target
        
        if(value === "") { 
            value = null
        }
        props.setReadingType(prev => {
            return {
                ...prev,
                [id ? id : name]: type === "checkbox" ? checked : value
            }
        })
    }

    let currentDataType = props.dataTypes.find((dataType) => dataType.id === props.readingType.dataTypeId)?.dataType;
    let currentSensor = props.sensors.find((sensor) => sensor.id === props.readingType.sensorId)?.name;

    return (
        <Box 
            sx={{
                p:1,
                m:1
            }}>
            <Box>
                <AxionControls.AxionTextBox 
                    name="name"
                    label={<FormattedMessage {...messages.readingTypeNameColumn} />}
                    value={props.readingType.name}
                    onChange={handleChange}
                    />
                <AxionControls.AxionTextBox 
                    name="description"
                    label={<FormattedMessage {...messages.readingTypeDescriptionColumn} />}
                    value={props.readingType.description}
                    onChange={handleChange}
                    />
                <AxionControls.AxionTextBoxReadOnly 
                    name="channel"
                    label={<FormattedMessage {...messages.channelColumn} />}
                    value={props.readingType.channel}
                    />
                <AxionControls.AxionTextBoxReadOnly 
                    name="axis"
                    label={<FormattedMessage {...messages.axisColumn} />}
                    value={props.readingType.axis}
                    />
                <AxionControls.AxionTextBoxReadOnly 
                    name="dataType"
                    label={<FormattedMessage {...messages.dataTypeColumn} />}
                    value={currentDataType}
                    />
                <AxionControls.AxionTextBoxReadOnly 
                    name="sensor"
                    label={<FormattedMessage {...messages.sensorColumn} />}
                    value={currentSensor}
                    />
                <AxionControls.AxionTextBox 
                    name="sortOrder"
                    label={<FormattedMessage {...messages.sortOrderColumn} />}
                    value={props.readingType.sortOrder}
                    onChange={handleChange}
                    />
                <AxionControls.AxionTextBox 
                    name="conversionFactor"
                    label={<FormattedMessage {...messages.conversionFactorColumn} />}
                    value={props.readingType.conversionFactor}
                    onChange={handleChange}
                    />

                <Checkbox
                    name="visible"
                    label={<FormattedMessage {...messages.visibleColumn} />}
                    value={props.readingType.visible}
                    onChange={handleChange}
                    /><br />
                <Box>
                    <Button 
                        text={<FormattedMessage {...messages.save} />}
                        variant="contained" 
                        onClick={props.onReadingTypeSave}
                        />
                </Box>
            </Box>
        </Box>
    );
}